module.exports = __webpack_public_path__ + "static/media/feature7.a5cc72f7.png";